import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UserDetail } from '../state-man/models/user-detail.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})

export class UserDetailService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
    ) {
  }

  public async getByUserId (user_id: number) : Promise<UserDetail | null> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'user/' + user_id)          
      return UserDetail.buildOne(ret)
    } catch (error) {
      LoggerService.log(error + 'user/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }
  }  
}
